import orderConstants, { FormFiels } from '../Order/constants'
import marketingOrderConstants from './constants'
import * as common from "../../lib/common"

const initialState = {
  requesting: false,
  successful: false,
  messages: [],
  errors: [],
  warnings: [],
  usersChecked: [],
  customerInfor: {},
  thuocInfor: {},
  orderInfor: {},
  formData: null,
  enabledAddItem: false,
  items: [],
  orderId: '',
  mode: marketingOrderConstants.MODE.IN_CREATE,
  typeOfOrder: orderConstants.TYPEOF_ORDER.FOR_DEFAULT,
  callback: null,
  orderHistory: [],
  orderExport: {},
}

const reducer = function marketingOrderReducer(state = initialState, action) {
  let orderInfor = null

  switch (action.type) {
    case marketingOrderConstants.SET_MODE_FORM:
      return {
        ...state,
        mode: action.payload
      }
    case marketingOrderConstants.SET_USERS_CHECKED:
      return {
        ...state,
        usersChecked: action.payload
      }
    case marketingOrderConstants.SET_FLAG_ADD_ITEM:
      return {
        ...state,
        enabledAddItem: action.payload
      }
    case marketingOrderConstants.SET_ORDER_ID:
      return {
        ...state,
        errors: [],
        warnings: [],
        items: [],
        usersChecked: [],
        customerInfor: {},
        thuocInfor: thuocInfor,
        formData: null,
        orderInfor: {},
        orderId: action.payload,
      }
    case marketingOrderConstants.RESET_FORM:
      orderInfor = { items: [] }
      orderInfor[FormFiels.NgayLap] = common.currentDate()
      return {
        ...state,
        errors: [],
        warnings: [],
        items: [],
        khoXuats: [],
        usersChecked: [],
        customerInfor: {},
        customers: [],
        thuocInfor: {},
        formData: null,
        orderInfor: orderInfor,
        orderId: '',
        mode: marketingOrderConstants.MODE.IN_CREATE,
        callback: () => { }
      }
    case marketingOrderConstants.SET_CALLBACK_FUNC:
      return {
        ...state,
        callback: action.payload,
      }
    case marketingOrderConstants.UNLOCK_ORDER:
      return {
        ...state,
      }
    case marketingOrderConstants.SAVE_ORDER:
      return {
        ...state,
      }
    case marketingOrderConstants.SET_ORDER_INFOR:
      return {
        ...state,
        orderInfor: action.payload
      }
    case marketingOrderConstants.SET_ITEM:
      let items = state.items
      const product = action.payload
      const existed = items.findIndex(x => x.product_id === product.product_id && x.is_km == product.is_km)
      if (existed >= 0) {
        items.splice(existed, 1)
      }
      items.push(product)

      return {
        ...state,
        items: items
      }
    case marketingOrderConstants.SET_ITEMS:
      return {
        ...state,
        items: action.payload
      }
    case marketingOrderConstants.SET_WARNING_ITEM:
      return {
        ...state,
        warnings: [{
          body: action.payload,
          time: new Date(),
        }],
      }
    case marketingOrderConstants.SET_MESSAGE:
      return {
        ...state,
        messages: [{
          body: action.payload,
          time: new Date(),
        }],
        errors: []
      }
    case marketingOrderConstants.SET_ERROR:
      return {
        ...state,
        messages: [],
        errors: [{
          body: action.payload,
          time: new Date(),
        }]
      }
    case marketingOrderConstants.SET_IS_LOADING:
      return {
        ...state,
        requesting: action.payload
      }
    case marketingOrderConstants.SET_THUOCS:
      return {
        ...state,
        thuocs: action.payload
      }
    case marketingOrderConstants.SET_THUOC_INFO:
      const thuocInfor = action.payload
      return {
        ...state,
        thuocInfor: action.payload
      }
    case marketingOrderConstants.LOAD_THUOCS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.LOAD_THUOC_INFO:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.LOAD_KHOS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.SET_ORDER_HISTORY:
      return {
        ...state,
        orderHistory: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.SET_ORDER_EXPORT:
      return {
        ...state,
        orderExport: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.LOAD_ORDER_DETAILS:
      return {
        ...state,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.LOAD_CUSTOMER_INFO:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.SET_CUSTOMER_INFO:
      let customerInfor = action.payload
      orderInfor = state.orderInfor
      orderInfor[FormFiels.KhachHangId] = customerInfor.KhachHangId
      orderInfor[FormFiels.MaKhachHang] = customerInfor.MaKhachHang
      orderInfor[FormFiels.TenKhachHang] = customerInfor.Ten
      orderInfor[FormFiels.DiaChi] = customerInfor.DiaChi
      orderInfor[FormFiels.DienThoai] = customerInfor.DienThoai
      orderInfor[FormFiels.MaSoThue] = customerInfor.MaSoThue
      orderInfor[FormFiels.HdThamGia] = customerInfor.HdThamGia
      orderInfor[FormFiels.DiemTichLuy] = customerInfor.DiemTichLuy

      return {
        ...state,
        customerInfor: customerInfor,
        orderInfor: orderInfor,
      }
    case marketingOrderConstants.LOAD_CUSTOMERS:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.DELETE_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case marketingOrderConstants.APPROVE_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case marketingOrderConstants.PROCESS_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case marketingOrderConstants.RETURN_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case marketingOrderConstants.REVERT_ORDER:
      return {
        ...state,
        formData: action.payload
      }
    case marketingOrderConstants.LOAD_ORDER_HISTORY:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.LOAD_ORDER_EXPORT:
      return {
        ...state,
        formData: action.payload,
        messages: [],
        errors: []
      }
    case marketingOrderConstants.SET_ORDER_CONFIRM_MONEY:
      return {
        ...state,
        formData: action.payload
      }
    default:
      return state
  }
}

export default reducer



// WEBPACK FOOTER //
// ./src/views/MarketingOrder/reducer.js